import Assessment from 'components/assessment/Assessment';

const Signup = () => (
  <div className="col-md-8">
    <Assessment />
  </div>
);

export default Signup;
